import { render, staticRenderFns } from "./EditAgentForm.vue?vue&type=template&id=634a545a&scoped=true&"
import script from "./EditAgentForm.vue?vue&type=script&lang=js&"
export * from "./EditAgentForm.vue?vue&type=script&lang=js&"
import style0 from "./EditAgentForm.vue?vue&type=style&index=0&id=634a545a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634a545a",
  null
  
)

export default component.exports